/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import CursorLeft from '../../../../icons/CursorLeft';
import CursorRight from '../../../../icons/CursorRight';
import * as React from 'react';
import { Button } from 'reactstrap';
import { TournamentRound } from '../../../../services/betting';

interface NodeGridHeadingProps {
    childRounds: TournamentRound[];
    startColumn: number;
    columnCount: number;
    leftEnabled: boolean;
    rightEnabled: boolean;
    onColumnLeft: () => void;
    onColumnRight: () => void;
}

export class NodeGridHeading extends React.Component<NodeGridHeadingProps> {

    private static renderTournamentRound(tr: TournamentRound) {
        return (
            <th className="border-right text-center" key={tr.id}>
                {tr.name}
            </th>
        );

    }

    render() {
        if (this.props.childRounds) {
            return (
                <tr>
                    <th />
                    <th className="align-middle text-right border-right">
                        <Button className="btn-r1gray btn-sm" onClick={this.props.onColumnLeft} disabled={!this.props.leftEnabled}>
                           <CursorLeft />
                        </Button>
                    </th>
                    {this.props.childRounds.map((tr, index) => {
                        if (
                            index >= this.props.startColumn &&
                            index < this.props.startColumn + this.props.columnCount
                        ) {
                            return NodeGridHeading.renderTournamentRound(tr);
                        }
                        return null;
                    })}
                    <th className="align-middle">
                        <Button className="btn-r1gray btn-sm" onClick={this.props.onColumnRight} disabled={!this.props.rightEnabled}>
                            <CursorRight/>
                        </Button>
                    </th>
                </tr>
            );
        } else {
            return <tr />;
        }
    }

}
